import { render, staticRenderFns } from "./RegisterDialog.vue?vue&type=template&id=dd7e7528&scoped=true"
import script from "./RegisterDialog.vue?vue&type=script&lang=js"
export * from "./RegisterDialog.vue?vue&type=script&lang=js"
import style0 from "./RegisterDialog.vue?vue&type=style&index=0&id=dd7e7528&prod&lang=scss&scoped=true"
import style1 from "./RegisterDialog.vue?vue&type=style&index=1&id=dd7e7528&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd7e7528",
  null
  
)

export default component.exports